import React, { useState, useEffect } from "react";
import { Box, Form, Heading, Button, Anchor, Image, Text } from "../../components/elements";
import IconField from "../../components/fields/IconField";
import Logo from "../../components/Logo";
import data from "../../data/master/login.json";
import api from "../../data/master/api.json";
import { Alert } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function Logout() {

    const [user_name, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const navigate = useNavigate();
    const search = useLocation().search;
    const forward = search?encodeURIComponent(new URLSearchParams(search).get('forward'))?encodeURIComponent(new URLSearchParams(search).get('forward')):'/':'/'
    const handleSubmit = (e) => {
        e.preventDefault();
        doLogin(user_name, password);
    }; 
    console.log(forward)



    const doLogin = async (user_name, password) => {
        setAlertMessage('');
        await fetch(api.base_url+api.login, {
            method: 'POST',
            body: JSON.stringify({
                user_name: user_name,
                password: password
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                "Access-Control-Allow-Origin": "*"
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if ( data['status'] === 'error' ) {
                    setAlertMessage( data['message'] );
                } else if ( data['status'] === 'success' ) {
                    setAlertMessage('Signed in as ' + data['title']);
                    localStorage.setItem('session_id', data['session_id']);
                    localStorage.setItem('title', data['title']);
                    localStorage.setItem('user_name', user_name);
                    const year = new Date().getUTCFullYear();
                    const month = new Date().getUTCMonth() + 1; // Months are zero-based
                    const day = new Date().getUTCDate();
                    const hour = new Date().getUTCHours();
                    const minute = new Date().getUTCMinutes();
                    const utcMinus10Date = new Date(Date.UTC(year, month - 1, day, hour, minute) - (10 * 60 * 60 * 1000)).toISOString().slice(0, 10);                    
                    localStorage.setItem('session_id_date', utcMinus10Date);
                    navigate(forward);
                }
                
            })
            .catch((err) => {
                console.log(err.message);
            });
    };

    let valert;
    if (alertMessage !== '' ) {
        valert = <Alert key="abc123" variant="warning" onClose={() => setAlertMessage('')} dismissible>{alertMessage}</Alert>
    } else {
        valert = ""
    }

    useEffect(() => {
        localStorage.clear();
        navigate('/login?forward=' + forward);    
    }, [forward]); 



    return (
        <Box className="mc-auth">
            
            <Image
                src={ data?.pattern.src } 
                alt={ data?.pattern.alt }
                className="mc-auth-pattern"  
            />
            <Box className="mc-auth-group">
                <Logo 
                    src = { data?.logo.src }
                    alt = { data?.logo.alt }
                    href = { data?.logo.path }
                    className = "mc-auth-logo"
                />
                <Heading as="h4" className="mc-auth-title">{data?.title}</Heading>
                {valert}
                <Form className="mc-auth-form" >
                    
                    {data?.input.map((item, index) => (
                        <IconField 
                            key={index}
                            icon={item.icon}
                            type={item.type}
                            option={item.option}
                            classes={item.fieldSize}
                            placeholder={item.placeholder}
                            passwordVisible={item.passwordVisible}
                            onChange={(item.setter === "setUserName") ? (e) => setUserName(e.target.value) : (e) => setPassword(e.target.value)}
                        />
                    ))}
                    <Button className={`mc-auth-btn ${data?.button.fieldSize}`} type={data?.button.type} onClick={handleSubmit}>{ data?.button.text }</Button>
                    <Anchor className="mc-auth-forgot" href={ data?.forgot.path }>{ data?.forgot.text }</Anchor>
                </Form>

            </Box>
        </Box>
    );
}